import { add } from "date-fns";
import { se } from "date-fns/locale";
import * as e from "express";
import { last } from "rxjs-compat/operator/last";

export interface AdminDictionary {
    [key: string]: (
        // start_date?: string,
    ) => { es: string|any[]; us: string|any[] };
}

export const adminDictionary: AdminDictionary = {
    users: () => ({
        us: `Users`,
        es: `Usuarios`
    }),
    search_name: () => ({
        us: `Search by name`,
        es: `Buscar por nombre`
    }),
    search_company: () => ({
        us: `Search by company`,
        es: `Buscar por empresa`
    }),
    search_role: () => ({
        us: `Search by role`,
        es: `Buscar por rol`
    }),
    name: () => ({
        us: `Full Name`,
        es: `Nombre`
    }),
    email: () => ({
        us: `Email`,
        es: `Correo`
    }),
    company: () => ({
        us: `Company`,
        es: `Empresa`
    }),
    first_name: () => ({
        us: `First Name`,
        es: `Nombre`
    }),
    last_name: () => ({
        us: `Last Name`,
        es: `Apellido`
    }),
    default_page: () => ({
        us: `Default Page`,
        es: `Página por defecto`
    }),
    password: () => ({
        us: `Password`,
        es: `Contraseña`
    }),
    rep_password: () => ({
        us: `Repeat Password`,
        es: `Repetir Contraseña`
    }),
    delete_user: () => ({
        us: `Delete User`,
        es: `Eliminar Usuario`
    }),
    editing: () => ({
        us: `Editing...`,
        es: `Editando...`
    }),
    edit_user: () => ({
        us: `Edit User`,
        es: `Editar Usuario`
    }),
    add_user: () => ({
        us: `Add User`,
        es: `Agregar Usuario`
    }),
    save: () => ({
        us: `Save`,
        es: `Guardar`
    }),
    advance_settings: () => ({
        us: `Advance Settings`,
        es: `Configuración Avanzada`
    }),
    restricted_pages: () => ({
        us: `Restricted Pages`,
        es: `Páginas Restringidas`
    }),
    restricted_data: () => ({
        us: `Restricted Data`,
        es: `Datos Restringidos`
    }),
    apply: () => ({
        es: `Aplicar cambios`,
        us: `Apply changes`
    }),
    applied: () => ({
        es: `Configuración avanzada aplicada`,
        us: `Advance settings applied`
    }),
    need_save: () => ({
        es: `Necesita guardar cambios del usuario`,
        us: `You need to save user changes`
    }),
    advance_settings_description: () => ({
        es: `*Todos los cambios realizados en esta sección se aplicarán solo si se da clic en el botón "Guardar"`,
        us: `*All changes made in this section will be applied only if you click on the "Save" button`
    }),
    view_only: () => ({
        es: `Permitir ver información de...`,
        us: `Allow to view information of...`
    }),
    avialable_to_choose: () => ({
        es: `Disponible para elegir`,
        us: `Available to choose`
    }),
    select_company: () => ({
        es: `Seleccionar empresa`,
        us: `Select company`
    }),
    select_role: () => ({
        es: `Seleccionar rol`,
        us: `Select role`
    }),
    select_default_page: () => ({
        es: `Seleccionar página por defecto`,
        us: `Select default page`
    }),
    add_mult_users: () => ({
        es: `Añadir multiples analistas`,
        us: `Add multiple analysts`
    }),
    add_mult_users_description: () => ({
        es: `Este proceso te permite añadir multiples analistas a la vez. 
        Para ello, descarga la plantilla de CSV, llena los datos de los analistas y sube el archivo CSV con los datos.`,
        us: `This process allows you to add multiple analysts at once.
        To do this, download the CSV template, fill in the data of the analysts and upload the CSV file with the data.`
    }),
    add_mult_users_note_1: () => ({
        es: `*Nota: Los campos de la plantilla son obligatorios.`,
        us: `*Note: The fields in the template are mandatory.`
    }),
    add_mult_users_note_2: () => ({
        es: `**Nota: Esto solo permite dar de alta usuarios con el rol de analista.`,
        us: `**Note: This only allows you to register users with the role of analyst.`
    }),
    add_mult_users_upload: () => ({
        es: `Cargar CSV con analistas`,
        us: `Upload CSV with analysts`
    }),
    add_mult_users_download: () => ({
        es: `Descargar plantilla de CSV`,
        us: `Download CSV template`
    }),
    invalid_data: () => ({
        es: `Datos inválidos`,
        us: `Invalid data`
    }),
    invalid_data_description: () => ({
        es: `Los siguientes registros que se encuentran en el documento CSV no son válidos, si usted desea continuar, 
        estos usuarios no se darán de alta, pero si desea corregir los datos, por favor vuelva a cargar el archivo CSV con las correcciones necesarias.`,
        us: `The following records found in the CSV document are not valid, if you want to continue,
        these users will not be registered, but if you want to correct the data, please reload the CSV file with the necessary corrections.`
    }),
    upload_csv: () => ({
        es: `Cargar CSV`,
        us: `Upload CSV`
    }),
    continue_without_invalid: () => ({
        es: `Continuar sin datos inválida`,
        us: `Continue without invalid data`
    }),
    valid_data: () => ({
        es: `Datos válidos`,
        us: `Valid data`
    }),
    valid_data_description: () => ({
        es: `Los siguientes usuarios se darán de alta en su compañía como analistas. Proximamente se les enviará un correo para poder establecer su contraseña.`,
        us: `The following users will be registered in your company as analysts. Soon they will be sent an email to establish their password.`
    }),
    save_valid_data: () => ({
        es: `Guardar usuarios válidos`,
        us: `Save valid users`
    }),

    // Reportes
    reports: () => ({
        us: `Reports`,
        es: `Reportes`
    }),
};